module.exports = __webpack_public_path__ + "assets/img/1603.b2d5eccf.png";